import React from "react";
import { useTranslation } from "react-i18next";

export default function DeliveryNoteDetailsDocTable({ documentation }) {
  const { t } = useTranslation();

  const header = documentation[0].map((col) => <th>{col.name}</th>);
  const content = documentation.map((row, rowi) => (
    <tr key={`doc-row-${rowi}`}>
      <td>{rowi + 1}</td>
      {row.map((col) => {
        let value;
        let width;
        let css;
        switch (col.type) {
          case "checkbox":
            value = col.value[0] ? "X" : "";
            width = 1;
            css = "text-end";
            break;
          default:
            value = col.value[0];
            break;
        }
        return (
          <td width={width} className={css}>
            {value}
          </td>
        );
      })}
    </tr>
  ));

  // ugly but works simple for now
  return (
    <div className="table-responsive">
      <table className="table table-delivery_note table-hover">
        <thead>
          <tr>
            <th width={1}>{t("common.line")}</th>
            {header}
          </tr>
        </thead>
        <tbody>{content}</tbody>
      </table>
    </div>
  );
}
